import { InfiniteData } from "@tanstack/react-query";

export function extractInfoFromInfiniteData<T>(
  data: InfiniteData<T> | undefined
): T[] {
  if (!data) return [];

  return data.pages.flatMap((page) => page);
}

interface List<T> {
  records: T[];
}

export function extractListRecords<T>(lists: List<T>[]): T[] {
  if (!lists) return [];
  return lists.flatMap((v) => v.records);
}

export function extractPropertyFromListRecords<
  K extends string | number | symbol,
  T = any
>(records: Record<K, T>[], propertyKey: K): T[] {
  return records.flatMap((record) => record[propertyKey]);
}
